import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { createContext, type JSX, useContext, useMemo } from 'react';
import useImportHeicTo from '../../hooks/use-import-heic-to';
import type { HeicToModule } from '../../types';
export type ImgProcessorsContextProviderProps = {
  children: React.ReactNode;
};
type ImageProcessors = {
  heic: HeicToModule | undefined;
  heicLoading: boolean;
};
export const ImgProcessorsContext = createContext<ImageProcessors>({
  heic: undefined,
  heicLoading: true
});
export const useImgProcessorsContext = () => {
  return useContext(ImgProcessorsContext);
};
export const ImgProcessorsContextProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [heicLoading, heic] = useImportHeicTo();
  let t1;
  if ($[0] !== heic || $[1] !== heicLoading) {
    t1 = {
      heic,
      heicLoading
    };
    $[0] = heic;
    $[1] = heicLoading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const contextValue = t1;
  let t2;
  if ($[3] !== children || $[4] !== contextValue) {
    t2 = <ImgProcessorsContext.Provider value={contextValue}>{children}</ImgProcessorsContext.Provider>;
    $[3] = children;
    $[4] = contextValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};